module.exports = __webpack_public_path__ + "fonts/VetoSans-BoldItalic_1.bdc6b28e.woff2";